// Import components
const { CategoryRoomCalculator } = require('./components/CategoryRoomCalculator.js');

// Initialize the application
function createRoomStore() {
    const { createStore } = Vuex;

    return createStore({
        state() {
            return {
                rooms: [],
                primaryRoomIndex: 1,
                unit: 'm2'
            }
        }
    });
}

function initRoomCalculator() {
    const { createApp } = Vue;

    const roomStore = createRoomStore();

    const app = createApp(CategoryRoomCalculator);
    app.use(roomStore);
    
    // Mount the app if element exists
    const mountElement = document.getElementById('category-calculator-app');
    if (mountElement) {
        app.mount(mountElement);
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initRoomCalculator);